// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"c0a5cac6","453":"bb0a875a","457":"971e53c7","577":"48cf54a6","783":"54e921db"}[chunkId] + ".chunk.js";
};